<div class="modal-container" fxLayout="row">

    <!-- SIDEBAR -->
    <div class="sidebar" fxFlex="25">

        <h3 class="sidebar-title">Fórmulas</h3>

        <mat-selection-list [multiple]="false">
            <mat-list-option *ngFor="let exp of expressionList" (click)="getExpressionItem(exp)"
                [selected]="exp === expressionItem">

                {{ exp.title }}

            </mat-list-option>
        </mat-selection-list>

    </div>

    <!-- CONTEÚDO -->
    <div class="content">

        <mat-card class="card-form">

            <mat-card-title>
                {{ expressionItem?.title }}
            </mat-card-title>

            <mat-divider></mat-divider>

            <!-- 🔥 SCROLL AQUI -->
            <form [formGroup]="calculatorGroup" class="form-body">

                <div class="fields">

                    <div *ngFor="let field of orderedExpressionItems" class="field-wrapper"
                        [style.flex]="getFlex(field.size)">

                        <!-- TEXT -->
                        <mat-form-field *ngIf="field.dataType === 'text'" appearance="outline" class="full-field"
                            [ngClass]="{'field-result': field.type === 'R'}">

                            <mat-label>{{ field.title }}</mat-label>

                            <textarea matInput [formControlName]="field.name" [readonly]="field.type === 'R'"
                                cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="20">
    </textarea>

                            <mat-icon matSuffix *ngIf="field.type === 'R'">functions</mat-icon>
                        </mat-form-field>

                        <!-- STRING -->
                        <mat-form-field *ngIf="field.dataType === 'string'" appearance="outline" class="full-field"
                            [ngClass]="{'field-result': field.type === 'R'}">

                            <mat-label>{{ field.title }}</mat-label>

                            <input matInput type="text" [formControlName]="field.name"
                                [readonly]="field.type === 'R'" />

                            <mat-icon matSuffix *ngIf="field.type === 'R'">functions</mat-icon>
                        </mat-form-field>

                        <!-- NUMBER -->
                        <mat-form-field *ngIf="field.dataType === 'number'" appearance="outline" class="full-field"
                            [ngClass]="{'field-result': field.type === 'R'}">

                            <mat-label>{{ field.title }}</mat-label>

                            <input matInput type="number" [formControlName]="field.name"
                                [readonly]="field.type === 'R'" />

                            <mat-icon matSuffix *ngIf="field.type === 'R'">functions</mat-icon>
                        </mat-form-field>

                        <!-- SELECT -->
                        <mat-form-field *ngIf="field.dataType === 'select'" appearance="outline" class="full-field"
                            [ngClass]="{'field-result': field.type === 'R'}">

                            <mat-label>{{ field.title }}</mat-label>

                            <mat-select [formControlName]="field.name" [multiple]="field.multiple">

                                <mat-option *ngFor="let opt of (field.options || [])" [value]="opt.value">
                                    {{opt.label}}
                                </mat-option>

                            </mat-select>

                            <mat-icon matSuffix *ngIf="field.type === 'R'">functions</mat-icon>
                        </mat-form-field>

                        <!-- TIME -->
                        <mat-form-field *ngIf="field.dataType === 'time'" appearance="outline" class="full-field"
                            [ngClass]="{'field-result': field.type === 'R'}">

                            <mat-label>{{ field.title }}</mat-label>

                            <input matInput type="time" [formControlName]="field.name"
                                [readonly]="field.type === 'R'" />

                            <mat-icon matSuffix *ngIf="field.type === 'R'">functions</mat-icon>
                        </mat-form-field>

                        <!-- DATE -->
                        <mat-form-field *ngIf="field.dataType === 'date'" appearance="outline" class="full-field"
                            [ngClass]="{'field-result': field.type === 'R'}">

                            <mat-label>{{ field.title }}</mat-label>

                            <input matInput [matDatepicker]="picker" [formControlName]="field.name"
                                [readonly]="field.type === 'R'">

                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

                            <mat-datepicker #picker></mat-datepicker>

                            <mat-icon matSuffix *ngIf="field.type === 'R'">functions</mat-icon>
                        </mat-form-field>
                    </div>
                </div>


            </form>

        </mat-card>

        <!-- FOOTER -->
        <div class="footer">

            <button mat-stroked-button color="warn" (click)="closeModal()">
                Finalizar
            </button>

            <button mat-raised-button color="primary" matTooltip="Calcular e Salvar" (click)="calculate()">
                Salvar
            </button>

        </div>

    </div>

</div>